module.exports = __webpack_public_path__ + "static/image/sustainability/img-happiness-2025-en.ver2_0_2.jpg?8017e97e";